import { ApiError, type ApiErrorOptions } from "~/common/error/api-error";

/**
 * Specialized error class for validation errors
 * Extends ApiError to provide additional context for validation failures
 */
export class ValidationApiError extends ApiError {
  constructor(options: ApiErrorOptions) {
    super(options);
    this.name = "ValidationApiError";
  }
}
